import { useEffect } from "react";

const OG_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/d15c7f93-dbeb-4a10-bb00-1c12e4d13624/images/70fb72629dcb6b36b014a7435d9f07ca1ae8e24640b2c29a8fcd67304ffcfd80.jpeg";

function setMeta(attr, key, content) {
  if (!content) return;
  let tag = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

function setLink(rel, href) {
  if (!href) return;
  let tag = document.head.querySelector(`link[rel="${rel}"]`);
  if (!tag) {
    tag = document.createElement("link");
    tag.setAttribute("rel", rel);
    document.head.appendChild(tag);
  }
  tag.setAttribute("href", href);
}

// Lightweight SEO helper: title, description, canonical, robots, Open Graph +
// Twitter, and optional JSON-LD.
export default function Seo({ title, description, jsonLd, type = "website", image = OG_IMAGE, noindex = false }) {
  useEffect(() => {
    if (title) document.title = title;
    // Clean canonical/og:url — strip query strings and hashes so paginated or
    // parameterised URLs don't read as duplicate content.
    const url = `${window.location.origin}${window.location.pathname}`;
    setMeta("name", "description", description);
    setMeta("name", "robots", noindex ? "noindex, follow" : "index, follow");
    setLink("canonical", url);

    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", type);
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", image);
    setMeta("property", "og:site_name", "It's Genie Assist");

    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", image);
  }, [title, description, type, image, noindex]);

  useEffect(() => {
    if (!jsonLd) return;
    // Emit each schema as its own <script> block so crawlers/tools that expect
    // a single schema per tag reliably pick up every type (e.g. FAQPage).
    const blocks = Array.isArray(jsonLd) ? jsonLd : [jsonLd];
    const els = blocks.map((block) => {
      const el = document.createElement("script");
      el.type = "application/ld+json";
      el.text = JSON.stringify(block);
      document.head.appendChild(el);
      return el;
    });
    return () => {
      els.forEach((el) => document.head.removeChild(el));
    };
  }, [jsonLd]);

  return null;
}
